export interface ITenantsList {
  totalCount: number
  totalPageCount: number
  resultCount: number
  morePages: boolean
  currentPage: number
  result: ITenantsListResult[]
}

export interface ITenantsListResult {
  id: string
  identificationFields: {
    propertyNumber: string
    sectionNo: number
    propertySectionNo: string
    propertySharedNo: string
  }
  tenants: string[]
  unitAddress: { address: string }
  tenantsDetails: ITenantsDetails[]
  owners: string[]
  clientId: string
}

export interface ITenantsDetails {
  id: string
  firstName: string
  lastName: string
  from: Date
  to: Date
}

export interface ITenantsFilters {
  searchText: string
  sortColumn: string | null
  sortorder: string
  take: number
  skip: number
}

export interface IExpiringTenant {
  tenantId: string
  fullName: string
  firstName: string
  surname: string
  fromDate: Date
  toDate: Date
  unitId: string
  address: string
  zip: string
  city: string
  ssbNo: string
  sectionNo: number
  propertySectionNo: string
  status: string
}

export enum TenantsSortFieldEnum {
  propertyNumber = 'PropertyNumber',
  sectionNumber = 'ShareOrSectionNumber',
  tenants = 'Tenants',
  address = 'Address',
  owners = 'Owners',
}
